import createIcon from '../../createIcon';

/**
 * @component @name SupervisorAccount
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYuNSAxMkMxNy44OCAxMiAxOC45OSAxMC44OCAxOC45OSA5LjVDMTguOTkgOC4xMiAxNy44OCA3IDE2LjUgN0MxNS4xMiA3IDE0IDguMTIgMTQgOS41QzE0IDEwLjg4IDE1LjEyIDEyIDE2LjUgMTJaTTkgMTFDMTAuNjYgMTEgMTEuOTkgOS42NiAxMS45OSA4QzExLjk5IDYuMzQgMTAuNjYgNSA5IDVDNy4zNCA1IDYgNi4zNCA2IDhDNiA5LjY2IDcuMzQgMTEgOSAxMVpNMTYuNSAxNEMxNC42NyAxNCAxMSAxNC45MiAxMSAxNi43NVYxOUgyMlYxNi43NUMyMiAxNC45MiAxOC4zMyAxNCAxNi41IDE0Wk05IDEzQzYuNjcgMTMgMiAxNC4xNyAyIDE2LjVWMTlIOVYxNi43NUM5IDE1LjkgOS4zMyAxNC40MSAxMS4zNyAxMy4yOEMxMC41IDEzLjEgOS42NiAxMyA5IDEzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SupervisorAccount = createIcon('SupervisorAccount', [
  [
    'path',
    {
      d: 'M16.5 12C17.88 12 18.99 10.88 18.99 9.5C18.99 8.12 17.88 7 16.5 7C15.12 7 14 8.12 14 9.5C14 10.88 15.12 12 16.5 12ZM9 11C10.66 11 11.99 9.66 11.99 8C11.99 6.34 10.66 5 9 5C7.34 5 6 6.34 6 8C6 9.66 7.34 11 9 11ZM16.5 14C14.67 14 11 14.92 11 16.75V19H22V16.75C22 14.92 18.33 14 16.5 14ZM9 13C6.67 13 2 14.17 2 16.5V19H9V16.75C9 15.9 9.33 14.41 11.37 13.28C10.5 13.1 9.66 13 9 13Z',
      key: 'ddv09u',
    },
  ],
]);

export default SupervisorAccount;
